__turbopack_context__.v({
  "auth": "e25pIG_auth",
  "auth--continue": "e25pIG_auth--continue",
  "auth--sent": "e25pIG_auth--sent",
  "auth__actions": "e25pIG_auth__actions",
  "badge": "e25pIG_badge",
  "badge--admit": "e25pIG_badge--admit",
  "badge--reject": "e25pIG_badge--reject",
  "char-count": "e25pIG_char-count",
  "char-count__limits": "e25pIG_char-count__limits",
  "consent": "e25pIG_consent",
  "corner-actions": "e25pIG_corner-actions",
  "intro": "e25pIG_intro",
  "intro__header": "e25pIG_intro__header",
  "intro__lead": "e25pIG_intro__lead",
  "lead": "e25pIG_lead",
  "lead--large": "e25pIG_lead--large",
  "lead--narrow": "e25pIG_lead--narrow",
  "legal": "e25pIG_legal",
  "legal--hidden": "e25pIG_legal--hidden",
  "legend-line": "e25pIG_legend-line",
  "legend-line--hint": "e25pIG_legend-line--hint",
  "loader": "e25pIG_loader",
  "page-application__co-brand": "e25pIG_page-application__co-brand",
  "photo-split": "e25pIG_photo-split",
  "photo-split--below-header": "e25pIG_photo-split--below-header",
  "photo-split--sticky-media": "e25pIG_photo-split--sticky-media",
  "photo-split--under-header": "e25pIG_photo-split--under-header",
  "progress": "e25pIG_progress",
  "progress__bar": "e25pIG_progress__bar",
  "progress__label": "e25pIG_progress__label",
  "progress__track": "e25pIG_progress__track",
  "review": "e25pIG_review",
  "review__acknowledgements": "e25pIG_review__acknowledgements",
  "review__panel": "e25pIG_review__panel",
  "review__steps": "e25pIG_review__steps",
  "review__title": "e25pIG_review__title",
  "screen-title": "e25pIG_screen-title",
  "screen-title--spaced": "e25pIG_screen-title--spaced",
  "sent": "e25pIG_sent",
  "sent__actions": "e25pIG_sent__actions",
  "sent__help": "e25pIG_sent__help",
  "sent__or": "e25pIG_sent__or",
  "sent__spinner": "e25pIG_sent__spinner",
  "slot-icon": "e25pIG_slot-icon",
  "slots": "e25pIG_slots",
  "slots__hint": "e25pIG_slots__hint",
  "slots__panel": "e25pIG_slots__panel",
  "slots__question": "e25pIG_slots__question",
  "slots__question--later": "e25pIG_slots__question--later",
  "sso": "e25pIG_sso",
  "sso__buttons": "e25pIG_sso__buttons",
  "sso__divider": "e25pIG_sso__divider",
  "sso__logo--apple": "e25pIG_sso__logo--apple",
  "sso__logo--google": "e25pIG_sso__logo--google",
  "status": "e25pIG_status",
  "status--open": "e25pIG_status--open",
  "status__column": "e25pIG_status__column",
  "status__meta": "e25pIG_status__meta",
  "status__progress": "e25pIG_status__progress",
  "status__row": "e25pIG_status__row",
  "status__title": "e25pIG_status__title",
  "step": "e25pIG_step",
  "step-title": "e25pIG_step-title",
  "step-title--wide": "e25pIG_step-title--wide",
  "tasks": "e25pIG_tasks",
  "tasks__body": "e25pIG_tasks__body",
  "tasks__title": "e25pIG_tasks__title",
  "term-group": "e25pIG_term-group",
  "term-label": "e25pIG_term-label",
  "tooltip-trigger": "e25pIG_tooltip-trigger",
});
